export const SUPPLIERS_ROUTES = {
    NOT_AUTHENTICATED: {
        signup: '/signup',
        confirmSignup: '/confirmSignup',
        login: '/login',
        forgotPassword: '/forgotPassword',
    },
    ONBOARDING: {
        register: '/register',
        onboarding: '/onboarding',
        confirmOnboarding: '/confirmOnboarding',
    },
    TRANSACTIONS: {
        transactions: '/transactions',
        transaction: '/transaction',
        tickets: '/tickets',
    },
    DIRECTORY: {
        directory: '/directory',
    },
    INVOICES: {
        invoices: '/invoices',
    },
    SHOPIFY: {
        shopify: '/shopify',
    },
    SETTINGS: {
        settings: '/settings',
    },
    VOUCHERS: {
        vouchers: '/vouchers',
        voucher: '/voucher',
    },
    NO_ACCESS: '/noaccess',
    MAIN: '/',
}

export const SUPPLIERS_PERMISSIONS_TO_VIEW = {
    directoryPage: {
        value: 'directoryPage',
        label: 'Directory',
        payload: 'directory',
        link: '/directory',
        routes: Object.keys(SUPPLIERS_ROUTES.DIRECTORY),
    },
    invoicesPage: {
        value: 'invoicesPage',
        label: 'Invoices',
        payload: 'invoices',
        link: '/invoices',
        routes: Object.keys(SUPPLIERS_ROUTES.INVOICES),
    },
    shopifyPage: {
        value: 'shopifyPage',
        label: 'Shopify',
        payload: 'shopify',
        link: '/shopify',
        routes: Object.keys(SUPPLIERS_ROUTES.SHOPIFY),
    },
    transactionsPage: {
        value: 'transactionsPage',
        label: 'Transactions',
        payload: 'transactions',
        link: '/transactions',
        routes: Object.keys(SUPPLIERS_ROUTES.TRANSACTIONS),
    },
    vouchersPage: {
        value: 'vouchersPage',
        label: 'Vouchers',
        payload: 'vouchers',
        link: '/vouchers',
        routes: Object.keys(SUPPLIERS_ROUTES.VOUCHERS),
    },
    settingsPage: {
        value: 'settingsPage',
        label: 'Settings',
        payload: 'settings',
        link: '/settings',
        routes: Object.keys(SUPPLIERS_ROUTES.SETTINGS),
    },
}

const SUPPLIER_ROUTES_TO_EXCLUDE = [
    SUPPLIERS_ROUTES.MAIN,
    SUPPLIERS_ROUTES.NOT_AUTHENTICATED.confirmSignup,
    SUPPLIERS_ROUTES.NOT_AUTHENTICATED.login,
    SUPPLIERS_ROUTES.NOT_AUTHENTICATED.signup,
    SUPPLIERS_ROUTES.NOT_AUTHENTICATED.forgotPassword,
    SUPPLIERS_ROUTES.ONBOARDING.onboarding,
    SUPPLIERS_ROUTES.ONBOARDING.confirmOnboarding,
    SUPPLIERS_ROUTES.ONBOARDING.register,
    SUPPLIERS_ROUTES.TRANSACTIONS.transactions,
]

// Management routes for redirecting
const MANAGEMENT_ROUTES_TO_EXCLUDE = [
    '/',
    '/onboarding',
    '/login',
    '/forgotPassword',
    '/signup',
    '/confirmSignup',
    '/summary',
]

const WORKSPACE_ROUTES_TO_EXCLUDE = []

// Used S&M/isAuthenticated()
export const REPOS_KEYS = {
    MANAGEMENT: 'MANAGEMENT',
    SUPPLIER: 'SUPPLIER',
    WORKSPACE: 'WORKSPACE',
}
// Used S&M/isAuthenticated()
export const isRedirectingRoute = (route, repoKey) => {
    if (!repoKey) {
        throw new Error('Please provide repository key')
    }

    const REPOS = {
        MANAGEMENT: MANAGEMENT_ROUTES_TO_EXCLUDE,
        SUPPLIER: SUPPLIER_ROUTES_TO_EXCLUDE,
        WORKSPACE: WORKSPACE_ROUTES_TO_EXCLUDE,
    }
    return REPOS[repoKey].includes(route)
}
